export default {"src":"/_next/static/media/check--accent-alt.8931b107.svg","height":54,"width":55};